import angular from 'angular'

import component from './error.component'

let module = angular.module('appError', [])

.component('appError', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/error/index.js